import { requester } from "App";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useState, useRef } from "react";
import videoImg from "resources/img/videoImg.png";
import poster from "resources/img/puffuPoster.png"
import poster2 from "resources/img/videoPoster.png"
import style from "./HorizontalVendingProductInfo.module.css";
import introTest from "resources/video/introTest.mp4"
import Test241122 from "resources/video/241122.mp4"
import Test241125 from "resources/video/test1125.mp4"
import iceSoda from "resources/video/iceSoda.mp4"
import pinkHibis from "resources/video/pinkHibis.mp4"
import ControlledYouTubePlayer from "routes/video/ControlledYouTubePlayer";
import DailymotionPlayer from "routes/video/DailymotionPlayer";
import Dummy from "components/Dummy";

function HorizontalVendingProductInfo(props) {
    const { data, currentTab, setCurrentTab } = props;
    const [score, setScore] = useState(4.7);
    const videoRef = useRef(null);
    
    // Add this useEffect to reset the video when data changes (product changes)
    useEffect(() => {
        // If video element exists, pause it and reset to beginning
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0; // 비디오를 처음으로 초기화
        }
    }, [data]); // This will run whenever the data prop changes

    // Helper function to determine which video source to use
    const getVideoSource = () => {
        if (!data || !data.productName) return Test241125;
        
        switch (data.productName) {
            case "핑크 히비스":
                return pinkHibis;
            case "소다 얼려먹구싶오":
                return iceSoda;
            default:
                return Test241125;
        }
    };

    return (
        <VerticalFlex height={"100%"}>
            <FlexChild>
                <div className={style.infoArea} style={{ height: "400px", backgroundColor: "transparent", borderRadius: "0" }}>
                    <VerticalFlex>
                        <FlexChild>
                            <Dummy height={"120px"} />
                            <video 
                                ref={videoRef}
                                controls 
                                style={{ 
                                    width: "100%", 
                                    objectFit: "cover", 
                                    height: "max-content", 
                                    border: "none" 
                                }} 
                                poster={poster2}
                            >
                                <source 
                                    style={{ border: "none" }} 
                                    src={getVideoSource()} 
                                    type="video/mp4" 
                                />
                            </video>
                        </FlexChild>
                    </VerticalFlex>
                </div>
            </FlexChild>
        </VerticalFlex>
    );
}

export default HorizontalVendingProductInfo;